import VerticalPage from "@/components/VerticalPage";
import { ChartLineUp } from "@phosphor-icons/react";

export default function Portfolio() {
  return (
    <VerticalPage
      eyebrow="OurHomebase · Portfolio"
      title="Portfolio"
      subtitle="Consolidated view across every asset class — rentals, royalties, notes, funds, and metals."
      IconLg={ChartLineUp}
      assetType="all"
    />
  );
}
